/* src/app/shared/contract/contract-list/contract-list.component.scss */
.main-container-wrapper {
  background-color: #FFF;
  padding: 5px;
}
.main-container {
  background-color: #001A33;
  border-radius: 20px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 10px);
  align-items: stretch;
  width: 100%;
}
.title-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #1F364D;
  border-radius: 16px;
  margin-bottom: 15px;
  padding: 15px;
}
.year-picker-and-button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.light-flex-card {
  background-color: #FFF;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 20px;
}
.title {
  font: 700 18px FranceTV Brown;
  color: #DFEBF7;
}
.sub-title {
  font: 700 16px FranceTV Brown;
  color: #001A33;
  margin-bottom: 15px;
}
.div-table-container {
  overflow: auto;
  height: calc(100vh - 270px) !important;
}
.filters-and-table-container {
  display: flex;
  flex-direction: column;
}
.table-search-export-container {
  background-color: #FFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
.font-ns {
  font: 700 14px FranceTV Brown;
  color: #001A33;
  padding: 0 20px 0 20px;
  text-align: center;
}
.icon-cell {
  cursor: pointer;
  text-align: center;
}
.agency-inactive {
  background-color: rgba(36, 70, 102, 0.05);
  color: #9e9e9e;
  font-style: italic;
}
.filters-div {
  padding: 0 20px 0 20px;
}
.icon-style {
  color: #0083FF;
}
.button-div {
  position: relative;
  padding: 0 20px 0 20px;
}
.left-margin-auto {
  margin-left: auto;
}
.small-icon {
  color: #FFF;
  font-size: 17px;
  height: 17px;
  width: 17px;
  margin-right: 7px;
}
/*# sourceMappingURL=contract-list.component.css.map */
